import { createResource, type RouteResource } from 'react-resource-router';

import type { ResourceDependencies } from '../../../common/types';

import { getSchedulesEndpoint } from './endpoints';
import type { SchedulesResponse } from './endpoints/types';

export const createSchedulesResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
): RouteResource<SchedulesResponse | null> =>
	createResource({
		type: 'schedulesResource',
		getKey: () => 'schedulesResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return getSchedulesEndpoint();
		},
		isBrowserOnly: true,
		depends,
	});
